import { Component, OnInit } from '@angular/core';
import {GoBaseComponent} from "../go-base.component";
import {GO_COMPONENTS} from "../../../enums/e-game-objects";
import {VALUE_TYPE} from "../../../enums/enums";

@Component({
  selector: 'go-live-decor',
  templateUrl: './go-live-decor.component.html',
  styles: []
})
export class GoLiveDecorComponent extends GoBaseComponent {

  VAL_TYPES = VALUE_TYPE;

  constructor() {
    super(GO_COMPONENTS.LIVE_DECOR);
  }


}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/go/go-live-decor/go-live-decor.component.ts